import { useEffect, useState } from "react";
import { contarProdutosComMidia, TipoMidiaN1 } from "../services/materiaisN1";
import { TipoMaterialN1 } from "../types/materiaisN1.types";

/**
 * FASE 05 — Ajustes 25/08 (plano de mídias, Etapa D / decisão F05A-P3b de 26/08).
 *
 * Quantos OUTROS produtos usam o nome de arquivo digitado. Gravar substitui a mídia de todos
 * eles — é a intenção do modelo (produtos que só diferem pela cor compartilham a mesma
 * figura), mas a tela precisa avisar antes: em produção há nome servindo 1.125 códigos.
 *
 * Só consulta quando o modal está aberto e há nome digitado, com atraso curto para não
 * disparar um request por tecla.
 */
export function useMidiaCompartilhada(
  ativo: boolean,
  tipoMaterial: TipoMaterialN1,
  tipoMidia: TipoMidiaN1,
  nomeArquivo: string | undefined,
  idProduto: number | undefined
): number {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!ativo || !nomeArquivo?.trim()) {
      setTotal(0);
      return;
    }

    let vivo = true;
    const timer = setTimeout(() => {
      contarProdutosComMidia(tipoMaterial, tipoMidia, nomeArquivo, idProduto).then((n) => {
        if (vivo) setTotal(n);
      });
    }, 400);

    return () => {
      vivo = false;
      clearTimeout(timer);
    };
  }, [ativo, tipoMaterial, tipoMidia, nomeArquivo, idProduto]);

  return total;
}
